export const SAVE_STATUSES = Object.freeze({
  SAVED: 'saved',
  UNSAVED: 'unsaved',
  SAVING: 'saving',
  ERROR: 'error',
});

const cloneRevisionValue = (value) => (
  typeof structuredClone === 'function'
    ? structuredClone(value)
    : JSON.parse(JSON.stringify(value))
);

export const resolveSaveStatus = ({
  isSaving = false,
  saveFailed = false,
  currentRevision = null,
  savedRevision = null,
} = {}) => {
  if (isSaving) return SAVE_STATUSES.SAVING;
  if (saveFailed) return SAVE_STATUSES.ERROR;
  return currentRevision !== null && currentRevision === savedRevision
    ? SAVE_STATUSES.SAVED
    : SAVE_STATUSES.UNSAVED;
};

export const createDocumentRevisionTracker = () => {
  let revisionCounter = 0;
  let currentRevision = null;
  const revisions = new WeakMap();

  return {
    get currentRevision() {
      return currentRevision;
    },

    register(documentData, revision = null) {
      if (!documentData) return null;
      const nextRevision = revision ?? (revisionCounter + 1);
      revisionCounter = Math.max(revisionCounter, nextRevision);
      currentRevision = nextRevision;
      revisions.set(documentData, nextRevision);
      return nextRevision;
    },

    cloneCurrent(documentData) {
      const snapshot = cloneRevisionValue(documentData);
      if (snapshot && currentRevision !== null) {
        revisions.set(snapshot, currentRevision);
      }
      return snapshot;
    },

    revisionOf(documentData) {
      return documentData ? revisions.get(documentData) : undefined;
    },
  };
};
